<template>
  <div class="mui-list-subtitle" role="menuitem">
    <span>{{title}}</span>
    <div class="mui-list-subtitle__actions" v-if="action">
      <i
        class="material-icons"
        role="button"
        :title="action.title"
        @click="action.fn">{{action.icon}}</i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MUIListSubtitle',
  props: {
    title: {
      required: true,
      type: String
    },
    action: Object
  }
}
</script>

<style lang="sass">
.mui-list-subtitle
  display: flex
  user-select: none
  margin: 12px 8px 2px 0
  // font-size: 11px
  padding: 0 6px
  // color: rgba(255, 255, 255, 0.7)
  span
    opacity: 0.64
    padding-left: 12px
    // text-transform: uppercase
  .mui-list-subtitle__actions
    margin-left: auto
    i
      cursor: pointer
      font-size: 22px
      opacity: 0.64
      transition: opacity .1s ease-out
    i:hover
      opacity: 1
</style>



// WEBPACK FOOTER //
// src/components/MUIListSubtitle.vue